export default axios => ({
  uploadFile: file => axios.post('/files/upload-chunk-file', (() => {
    const data = new FormData()

    data.append('file', file)

    return data
  })())
})
